/**
 * Maps API auth/profile payloads to the canonical user object stored in localStorage + Redux.
 */

export function buildAuthUserFromSignIn(data) {
  if (!data) return null;

  return {
    name: data.username,
    email: data.email,
    role: data.role,
    image: data.image,
    jobTitle: data.job_title,
    isVerified: data.is_verified,
    mfaMethod: data.mfa_method,
    phone: data.phone,
    id: data.id,
    theme: data.theme,
    require2FA: Boolean(data.require_2fa),
    requirePasswordUpdate: Boolean(data.require_password_update),
  };
}

export function buildAuthUserFromProfile(data, sessionOverrides = {}) {
  if (!data) return null;

  return {
    name: data.username,
    email: data.email,
    role: data.role,
    image: data.image,
    jobTitle: data.job_title,
    isVerified: data.is_verified,
    mfaMethod: data.mfa_method,
    phone: data.phone,
    id: data.id,
    theme: data.theme,
    require2FA:
      sessionOverrides.require2FA !== undefined ? Boolean(sessionOverrides.require2FA) : false,
    requirePasswordUpdate:
      sessionOverrides.requirePasswordUpdate !== undefined
        ? Boolean(sessionOverrides.requirePasswordUpdate)
        : false,
  };
}

/** After OTP verify or forced MFA setup — keep password flag if still required. */
export function buildAuthUserAfterMfaStep(profileData, previousUser) {
  return buildAuthUserFromProfile(profileData, {
    require2FA: false,
    requirePasswordUpdate: Boolean(previousUser?.requirePasswordUpdate),
  });
}

/** After successful password change — clear password flag; keep MFA enrollment if still required. */
export function buildAuthUserAfterPasswordUpdate(profileData, previousUser) {
  return buildAuthUserFromProfile(profileData, {
    require2FA: Boolean(previousUser?.require2FA),
    requirePasswordUpdate: false,
  });
}
